(function () {
  if (window.ClozsWishlist) return;

  var storageKey = 'clozs:wishlist:v1';
  var rootPath = (window.routes && window.routes.root_url ? window.routes.root_url : '/').replace(/\/$/, '');

  function readItems() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(parsed)) return [];
      var seen = {};
      return parsed.filter(function (item) {
        if (!item || !item.handle) return false;
        item.key = item.key || buildItemKey(item.handle, item.variantId || item.variant_id || item.id);
        if (seen[item.key]) return false;
        seen[item.key] = true;
        return true;
      });
    } catch (error) {
      return [];
    }
  }

  function writeItems(items) {
    window.localStorage.setItem(storageKey, JSON.stringify(items));
  }

  function formatMoney(cents) {
    var value = Number(cents || 0);

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(value, window.shopSettings && window.shopSettings.moneyFormat);
    }

    return 'LE ' + (value / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[character];
    });
  }

  function buildProductUrl(item) {
    var url = item.url || ((rootPath || '') + '/products/' + item.handle);
    if (!item.variantId) return url;

    try {
      var parsedUrl = new URL(url, window.location.origin);
      parsedUrl.searchParams.set('variant', item.variantId);
      return parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
    } catch (_error) {
      return url;
    }
  }

  function buildProductJsonUrl(handle) {
    return (rootPath || '') + '/products/' + handle + '.js';
  }

  function fetchProduct(handle) {
    return window.fetch(buildProductJsonUrl(handle), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) return null;
      return response.json();
    }).catch(function () {
      return null;
    });
  }

  function buildItemKey(handle, variantId) {
    return String(handle || '') + '::' + String(variantId || '');
  }

  function getButtonVariantId(button) {
    return button.getAttribute('data-product-variant-id') || button.getAttribute('data-variant-id') || '';
  }

  function getButtonVariantTitle(button) {
    return button.getAttribute('data-product-variant-title') || '';
  }

  function getButtonKey(button) {
    return buildItemKey(button.getAttribute('data-product-handle'), getButtonVariantId(button));
  }

  function getVariant(product, item) {
    if (!product || !Array.isArray(product.variants) || !item.variantId) return null;
    return product.variants.find(function (variant) {
      return String(variant.id) === String(item.variantId);
    }) || null;
  }

  function setButtonState(button, isActive) {
    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');

    var label = isActive ? window.wishlistStrings.added : window.wishlistStrings.add;
    button.setAttribute('aria-label', label);
    button.setAttribute('title', label);

    var text = button.querySelector('[data-wishlist-toggle-label]');
    if (text) text.textContent = label;
  }

  function updateToggleButtons(items) {
    var keys = items.map(function (item) { return item.key || buildItemKey(item.handle, item.variantId); });

    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      setButtonState(button, keys.indexOf(getButtonKey(button)) > -1);
    });
  }

  function updateCount(items) {
    var count = items.length;

    document.querySelectorAll('[data-wishlist-count]').forEach(function (node) {
      node.textContent = String(count);
      node.hidden = count < 1;
    });

    document.querySelectorAll('[data-wishlist-count-label]').forEach(function (node) {
      node.textContent = window.wishlistStrings.savedCount.replace('[count]', String(count));
    });
  }

  function renderItems(items) {
    var shell = document.querySelector('[data-wishlist-shell]');
    if (!shell) return;

    var list = shell.querySelector('[data-wishlist-items]');
    var empty = shell.querySelector('[data-wishlist-empty]');
    if (!list || !empty) return;

    list.innerHTML = '';

    if (!items.length) {
      empty.hidden = false;
      list.hidden = true;
      return;
    }

    empty.hidden = true;
    list.hidden = false;

    Promise.all(items.map(function (item) {
      return fetchProduct(item.handle).then(function (product) {
        return { item: item, product: product };
      });
    })).then(function (results) {
      list.innerHTML = '';
      var renderedCount = 0;
      var validItems = [];

      results.forEach(function (entry) {
        var item = entry.item;
        var product = entry.product;
        if (!product) return;
        validItems.push(item);

        var variant = getVariant(product, item);
        var productUrl = buildProductUrl(item);
        var imageSrc = variant && variant.featured_image && variant.featured_image.src
          ? variant.featured_image.src
          : product.featured_image;
        var variantTitle = item.variantTitle || (variant && variant.title && variant.title !== 'Default Title' ? variant.title : '');
        var price = variant && typeof variant.price !== 'undefined' ? variant.price : product.price;
        var imageMarkup = imageSrc
          ? '<img src="' + imageSrc + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
          : '<span class="clozs-wishlist-card__placeholder" aria-hidden="true">' + escapeHtml((product.title || item.title || 'C').charAt(0)) + '</span>';
        var soldOutLabel = window.variantStrings && window.variantStrings.soldOut ? window.variantStrings.soldOut : 'Sold out';
        var availabilityMarkup = (variant ? variant.available === false : product.available === false)
          ? '<span class="clozs-wishlist-card__badge">' + escapeHtml(soldOutLabel) + '</span>'
          : '';

        var article = document.createElement('article');
        article.className = 'clozs-wishlist-card';
        article.innerHTML =
          '<a class="clozs-wishlist-card__media" href="' + productUrl + '">' +
            imageMarkup +
            availabilityMarkup +
          '</a>' +
          '<div class="clozs-wishlist-card__body">' +
            '<a class="clozs-wishlist-card__title" href="' + productUrl + '">' + escapeHtml(product.title || item.title) + '</a>' +
            (variantTitle ? '<div class="clozs-wishlist-card__variant">' + escapeHtml(variantTitle) + '</div>' : '') +
            '<div class="clozs-wishlist-card__price">' + formatMoney(price) + '</div>' +
            '<div class="clozs-wishlist-card__actions">' +
              '<a class="clozs-wishlist-card__view" href="' + productUrl + '">' + window.wishlistStrings.viewProduct + '</a>' +
              '<button type="button" class="clozs-wishlist-card__remove" data-wishlist-remove="' + escapeHtml(item.key || buildItemKey(item.handle, item.variantId)) + '" aria-label="' + escapeHtml(window.wishlistStrings.remove) + ' ' + escapeHtml(product.title || item.title) + '">' + window.wishlistStrings.remove + '</button>' +
            '</div>' +
          '</div>';

        list.appendChild(article);
        renderedCount += 1;
      });

      if (validItems.length !== items.length) {
        writeItems(validItems);
        updateCount(validItems);
        updateToggleButtons(validItems);
      }

      empty.hidden = renderedCount > 0;
      list.hidden = renderedCount < 1;
    });
  }

  function sync() {
    var items = readItems();
    writeItems(items);
    updateToggleButtons(items);
    updateCount(items);
    renderItems(items);
  }

  function addItem(button) {
    var items = readItems();
    var handle = button.getAttribute('data-product-handle');
    var variantId = getButtonVariantId(button);
    var variantTitle = getButtonVariantTitle(button);
    var url = button.getAttribute('data-product-url');
    var title = button.getAttribute('data-product-title');
    var key = buildItemKey(handle, variantId);

    if (!handle) return;

    if (items.some(function (item) { return (item.key || buildItemKey(item.handle, item.variantId)) === key; })) return;

    items.unshift({
      key: key,
      handle: handle,
      variantId: variantId,
      variantTitle: variantTitle,
      url: url,
      title: title
    });

    writeItems(items);
    sync();
  }

  function removeItem(key) {
    var items = readItems().filter(function (item) {
      return (item.key || buildItemKey(item.handle, item.variantId)) !== key && item.handle !== key;
    });

    writeItems(items);
    sync();
  }

  function toggleItem(button) {
    var handle = button.getAttribute('data-product-handle');
    if (!handle) return;

    var items = readItems();
    var key = getButtonKey(button);
    var exists = items.some(function (item) { return (item.key || buildItemKey(item.handle, item.variantId)) === key; });

    if (exists) {
      removeItem(handle);
    } else {
      addItem(button);
    }
  }

  function openDrawer() {
    var shell = document.querySelector('[data-wishlist-shell]');
    var drawer = document.getElementById('clozs-wishlist-drawer');
    if (!shell || !drawer) return;

    shell.hidden = false;
    document.body.classList.add('clozs-wishlist-open');
    drawer.setAttribute('aria-hidden', 'false');

    document.querySelectorAll('[data-wishlist-open]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'true');
    });

    sync();
    window.requestAnimationFrame(function () {
      drawer.focus();
    });
  }

  function closeDrawer() {
    var shell = document.querySelector('[data-wishlist-shell]');
    var drawer = document.getElementById('clozs-wishlist-drawer');
    if (!shell || !drawer) return;

    shell.hidden = true;
    document.body.classList.remove('clozs-wishlist-open');
    drawer.setAttribute('aria-hidden', 'true');

    document.querySelectorAll('[data-wishlist-open]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-wishlist-open]');
    if (openButton) {
      event.preventDefault();
      openDrawer();
      return;
    }

    var closeButton = event.target.closest('[data-wishlist-close]');
    if (closeButton) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var toggleButton = event.target.closest('[data-wishlist-toggle]');
    if (toggleButton) {
      event.preventDefault();
      toggleItem(toggleButton);
      return;
    }

    var removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton) {
      event.preventDefault();
      removeItem(removeButton.getAttribute('data-wishlist-remove'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeDrawer();
    }
  });

  window.addEventListener('storage', function (event) {
    if (event.key === storageKey) {
      sync();
    }
  });

  window.ClozsWishlist = {
    sync: sync,
    open: openDrawer,
    close: closeDrawer
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync, { once: true });
  } else {
    sync();
  }
})();
